function n(i) {
  return i != null && !Number.isNaN(i);
}
export {
  n as isDefined
};
//# sourceMappingURL=isDefined.js.map
